import { createContext } from "react";

const AppContext = createContext<{ userInfo?: any }>({});

export default AppContext;
